import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../components/ui/alert-dialog';
import { Warning } from '@phosphor-icons/react';

export default function ConfirmDeleteDialog({ open, onOpenChange, title, description, onConfirm, destructiveLabel = 'Delete' }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center shrink-0">
              <Warning size={20} weight="bold" className="text-destructive" />
            </div>
            <div>
              <AlertDialogTitle
                className="text-lg font-bold"
                style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}
              >
                {title}
              </AlertDialogTitle>
              <AlertDialogDescription className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {description}
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-2">
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 rounded font-semibold"
            data-testid="confirm-delete-btn"
          >
            {destructiveLabel}
          </AlertDialogAction>
          <AlertDialogCancel
            className="rounded border-border bg-secondary text-foreground hover:bg-secondary hover:text-foreground focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 outline-none"
            data-testid="cancel-delete-btn"
          >
            Cancel
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
